import { render } from "./HQRequirements.vue?vue&type=template&id=15d57f5a&scoped=true"
import script from "./HQRequirements.vue?vue&type=script&lang=js"
export * from "./HQRequirements.vue?vue&type=script&lang=js"

import "./HQRequirements.vue?vue&type=style&index=0&id=15d57f5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15d57f5a"

export default script